export default "/build/images/profile-pic.7fef526e.png";